<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->
  
 
document.addEventListener("DOMContentLoaded", function () {
  function animateCounter(element, targetValue, duration, step = 4) {
    let currentValue = 0;
    const postfix = element.dataset.postfix || '';
    const decimalPlaces = (targetValue % 1 !== 0)
      ? targetValue.toString().split(".")[1].length
      : 0;

    const frameRate = 60; // frames per second
    const totalFrames = Math.round(duration / (1000 / frameRate));
    const increment = targetValue / totalFrames * step;

    const counter = setInterval(() => {
      currentValue += increment;

      if (currentValue >= targetValue) {
        currentValue = targetValue;
        clearInterval(counter);
      }

      element.textContent = currentValue.toFixed(decimalPlaces) + postfix;
    }, 1000 / frameRate);
  }

  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        document.querySelectorAll('.stat-number').forEach(stat => {
          const target = parseFloat(stat.dataset.target);
          const duration = 1500; // 1.5 seconds
          const step = 4; // 👈 change this to control speed (e.g. 2, 4, 8)
          animateCounter(stat, target, duration, step);
        });
        observer.disconnect();
      }
    });
  }, { threshold: 0.2 });

  observer.observe(document.getElementById('trusted-section'));
});

document.addEventListener("DOMContentLoaded", function () {
  const section = document.querySelector(".legacy-section");
  if (!section) return;

  const counters = section.querySelectorAll(".counter");
  let started = false;

  function animateCounter(counter) {
    // Extract number only for calculations
    const target = parseFloat(counter.getAttribute("data-target"));

    // Detect any symbol inside <span> (like + or %)
    const symbolSpan = counter.querySelector("span");
    const symbol = symbolSpan ? symbolSpan.outerHTML : "";

    let startValue = 0;
    let step = 1;

    // --- Logic for small numbers (<10) ---
    if (target < 10) {
      startValue = Math.ceil(target * 0.2);
      step = Math.ceil(target / 5);
    }
    // --- Logic for mid-range numbers (10-100) ---
    else if (target <= 100) {
      startValue = Math.floor(target * 0.2);
      step = Math.ceil(target / 5);
    }
    // --- Logic for larger numbers ---
    else if (target <= 1000) {
      startValue = Math.floor(target * 0.2);
      step = 100;
    } else {
      startValue = Math.floor(target * 0.1);
      step = Math.round(target / 5);
    }

    let current = startValue;
    counter.innerHTML = Math.floor(current) + symbol;

    const interval = setInterval(() => {
      current += step;

      if (current >= target) {
        current = target;
        clearInterval(interval);
      }

      counter.innerHTML = Math.floor(current) + symbol;
    }, 200); // speed between steps
  }

  function onScroll() {
    if (started) return;

    const rect = section.getBoundingClientRect();
    if (rect.top < window.innerHeight && rect.bottom > 0) {
      counters.forEach(counter => animateCounter(counter));
      started = true;
      window.removeEventListener("scroll", onScroll);
    }
  }

  window.addEventListener("scroll", onScroll);
});







$('.offer-slide').slick({
  dots: true,
  infinite: true,
  speed: 300,
  slidesToShow: 1,
  slidesToScroll: 1,
  dots:false,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});

$(".job-slider").slick({
  slidesToShow: 3.5,
  slidesToScroll: 1,
  infinite: false,
  dots: true,
  arrows: true,
  autoplay: false,
  autoplaySpeed: 3000,
  prevArrow: `
          <button type="button" class="slick-prev">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
  <path d="M13.3844 2.04469C13.6188 2.2791 13.7504 2.59699 13.7504 2.92844C13.7504 3.2599 13.6188 3.57778 13.3844 3.81219L7.19692 9.99969L13.3844 16.1872C13.6121 16.4229 13.7381 16.7387 13.7353 17.0664C13.7324 17.3942 13.601 17.7077 13.3692 17.9395C13.1374 18.1712 12.8239 18.3027 12.4962 18.3055C12.1684 18.3084 11.8527 18.1824 11.6169 17.9547L4.54567 10.8834C4.31133 10.649 4.17969 10.3311 4.17969 9.99969C4.17969 9.66824 4.31133 9.35035 4.54567 9.11594L11.6169 2.04469C11.8513 1.81036 12.1692 1.67871 12.5007 1.67871C12.8321 1.67871 13.15 1.81036 13.3844 2.04469Z" fill="black"/>
</svg>
          </button>
        `,
        nextArrow: `
          <button type="button" class="slick-next">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path d="M13.3844 2.04469C13.6188 2.2791 13.7504 2.59699 13.7504 2.92844C13.7504 3.2599 13.6188 3.57778 13.3844 3.81219L7.19692 9.99969L13.3844 16.1872C13.6121 16.4229 13.7381 16.7387 13.7353 17.0664C13.7324 17.3942 13.601 17.7077 13.3692 17.9395C13.1374 18.1712 12.8239 18.3027 12.4962 18.3055C12.1684 18.3084 11.8527 18.1824 11.6169 17.9547L4.54567 10.8834C4.31133 10.649 4.17969 10.3311 4.17969 9.99969C4.17969 9.66824 4.31133 9.35035 4.54567 9.11594L11.6169 2.04469C11.8513 1.81036 12.1692 1.67871 12.5007 1.67871C12.8321 1.67871 13.15 1.81036 13.3844 2.04469Z" fill="black"/>
            </svg>
            
          </button>
        `,
  responsive: [
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1.2
      }
    }
  ]
});